import React, { Component } from "react";
import SpeedIcon from "../../../CarPopup/images/speed.svg";
import PlaceholderCar from "../../images/placeholder-car.svg";
import Clock from "../../images/ic-clock.svg";
import Check from "../../images/ic-check.svg";

import styles from "./ListItems.css";
import { PowerStatus } from "../../../PowerStatus";
import { ListItem } from "./ListItem";

interface Props {
  vehicleRegistrationPlate: null | string;
  ignitionOn: boolean;
  brand: null | string;
  model: null | string;
  speed: number;
  driverName: null | string;
  isRealTimeUpdated: boolean;
  arrived: boolean;
}

const getCheckIcon = (isRealTimeUpdated: boolean, arrived: boolean) => {
  if (arrived) {
    return null;
  }

  if (isRealTimeUpdated) {
    return <Check className={styles.subClockIcon} />;
  }

  return <Clock className={styles.subClockIcon} />;
};

export const VehicleListItem = ({
  vehicleRegistrationPlate,
  ignitionOn,
  brand,
  model,
  speed,
  driverName,
  isRealTimeUpdated,
  arrived
}: Props) => (
  <ListItem
    icon={
      <div className={styles.subIconContainer}>
        <PlaceholderCar className={styles.icon} />
        {!arrived && (
          <div className={styles.subIcon}>
            {getCheckIcon(isRealTimeUpdated, arrived)}
          </div>
        )}
      </div>
    }
    firstLine={
      <>
        {vehicleRegistrationPlate || "Placa não cadastrada"}
        {!arrived && <PowerStatus ignitionOn={ignitionOn} />}
      </>
    }
    secondLine={
      <>
        {model ? `${brand} ${model}` : "Modelo não cadastrado"}
        {!arrived && ignitionOn && (
          <span className={styles.speedIconContainer}>
            <SpeedIcon className={styles.speedIcon} />
            {Math.round(speed)} km/h
          </span>
        )}
      </>
    }
    thirdLine={driverName || "Motorista não associado"}
  />
);
